import { useBalances } from "@/api/balances"
import { Card, CardContent } from "@/components/ui/card"
import Loader from "@/components/layout/loader"
import BalancesCarousel from "./balances-carousel"
import WithdrawalsTable from "./withdrawals.table"
import Container from "@/components/ui/container"
import WithdrawalButton from "@/wallet/withdrawal.button"
import Balance from "./balance"
import { useNavigate, useParams } from "react-router-dom"
import { WithdrawalDetailsSheet } from "./withdrawal-details.sheet"

export default function BalancesHomeScreen() {
  const { currentBalance, totalPayments, totalWithdrawals, balances, isLoading } =
    useBalances()
  const { withdrawalId } = useParams()
  const navigate = useNavigate()

  if (isLoading) return <Loader message="Loading balances" />

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col md:flex-row gap-4">
        <Card className="shadow-sm md:max-w-96">
          <CardContent>
            <div className="flex flex-col gap-4">
              <div className="flex flex-col gap-2">
                <h3 className="text-sm font-normal text-gray-300">
                  Current balance
                </h3>
                <div className="text-xl font-semibold">
                  ${currentBalance.toFixed(2)}
                </div>
              </div>
              <Balance
                totalPayments={totalPayments}
                totalWithdrawals={totalWithdrawals}
              />
              <WithdrawalButton />
            </div>
          </CardContent>
        </Card>
        <div className="md:shadow-sm md:border rounded-md md:p-6 flex-grow">
          <BalancesCarousel balances={balances || []} />
        </div>
      </div>
      <Container>
        <div className="flex flex-row justify-between items-center pb-4">
          <div className="text-md font-semibold">Last Withdrawals</div>
        </div>
        <WithdrawalsTable />
      </Container>
      {withdrawalId && (
        <WithdrawalDetailsSheet
          id={withdrawalId}
          onClose={() => navigate("/balances")}
        />
      )}
    </div>
  )
}
